import {
  DefaultEntityFilters,
  EntityAutocompletePicker,
  EntityFilter,
} from '@backstage/plugin-catalog-react';
import { ANNOTATION_USER_ROLE } from '@appfolio/backstage-plugin-catalog-common';

const FACET = `metadata.annotations.${ANNOTATION_USER_ROLE}`;

class EntityUserRoleFilter implements EntityFilter {
  public constructor(readonly values: string[]) {}

  public getCatalogFilters(): Record<string, string | string[]> {
    return { [FACET]: this.values };
  }

  public toQueryValue(): string[] {
    return this.values;
  }
}

export const EntityUserRolePicker = () => (
  <EntityAutocompletePicker<
    DefaultEntityFilters & {
      userRole: EntityUserRoleFilter;
    }
  >
    label="Role"
    name="userRole"
    path={FACET}
    Filter={EntityUserRoleFilter}
  />
);
